function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */
import Cocktail from '../lib/cocktail';
import FlowEventsMixin from './mixins/flow-events-mixin';
import FormView from './form';
import Template from 'templates/redirect_loading.mustache';
import PaymentServer from '../lib/payment-server';
import Url from '../lib/url';

let SubscriptionsProductRedirectView = /*#__PURE__*/function (_FormView) {
  _inherits(SubscriptionsProductRedirectView, _FormView);

  var _super = _createSuper(SubscriptionsProductRedirectView);

  function SubscriptionsProductRedirectView() {
    var _this;

    _classCallCheck(this, SubscriptionsProductRedirectView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "template", Template);

    return _this;
  }

  _createClass(SubscriptionsProductRedirectView, [{
    key: "initialize",
    value: function initialize(options) {
      this._currentPage = options.currentPage;
      this._productId = this._currentPage.split('/').pop();
      this.relier.set('subscriptionProductId', this._productId);
      this._subscriptionsConfig = {};

      if (options && options.config && options.config.subscriptions) {
        this._subscriptionsConfig = options.config.subscriptions;
      } // Flow events need to be initialized before the navigation
      // so the flow_id and flow_begin_time are propagated


      this.initializeFlowEvents();
    }
  }, {
    key: "render",
    value: function render() {
      const account = this.getSignedInAccount();
      return Promise.resolve().then(() => {
        const isSignedInPromise = (account === null || account === void 0 ? void 0 : account.isSignedIn()) || Promise.resolve(false);
        return isSignedInPromise.then(isSignedIn => {
          this._queryParams = Url.searchParams(this.window.location.search);
          const forceSignin = !!this._queryParams.signin;
          this._redirectPath = !isSignedIn && this._subscriptionsConfig.allowUnauthenticatedRedirects && !forceSignin ? `checkout/${this._productId}` : `products/${this._productId}`;
          this.mustAuth = this._redirectPath.startsWith('products');
        });
      }).finally(() => FormView.prototype.render.bind(this)());
    }
  }, {
    key: "afterRender",
    value: function afterRender() {
      delete this._queryParams.signin;
      return PaymentServer.navigateToPaymentServer(this, this._subscriptionsConfig, this._redirectPath, this._queryParams);
    }
  }]);

  return SubscriptionsProductRedirectView;
}(FormView);

Cocktail.mixin(SubscriptionsProductRedirectView, FlowEventsMixin);
export default SubscriptionsProductRedirectView;